import { useEffect, React } from "react";
import { domReady } from "../../helper/domReady";
import Portal from "../../globalComponents/Portal";
import { HeroBanner300px } from "../../globalComponents/300pxHeroBanner";
import './style.css'
import AgendaHeader from "./components/AgendaHeader"
import { addPageClass } from "../../helper/addPageClass";

const AgendaPage = (props) => {
  const contentContainer = document.querySelector(".rf-org-header-container");

  useEffect(() => {
    addPageClass("agendaPage");
  });

  domReady(() => {
    console.log('checkbox found')
    var checkbox = document.querySelector('.agendaPage input[data-test="favorites-filter"]');
    if (checkbox && !checkbox.checked) {
      checkbox.click();
      console.log('checkbox clicked')
    }
  }, '.agendaPage input[data-test="favorites-filter"]');

  return (
    <>
      <Portal container={contentContainer}>
        <HeroBanner300px
          h1={"Review the Agenda"}
          p={
            "Scroll through the agenda to view the dates and times of the sessions during Innovation 2022."
          }
          backgroundImgUrl={
            "https://static.rainfocus.com/intel/innovation2022/static/staticfile/staticfile/hero%20img%20bg%20innovation-2022_16595494141090019H1e.png"
          }
          env={props.env}
        />
        <AgendaHeader />
      </Portal>

    </>
  );
};

export { AgendaPage };

